// Full-document render of the sealy CustomerContentHubRootPage: PageSkeleton
// (the React document shell) wrapping the hub header (love_root is the page
// itself) and the shared TempurLove grid body, whose props arrive flattened
// on this template. Both grid routes (default and c/<category>/) render this
// same document.
import React from "react";

import { templates } from "@reactivated";

import { CustomerContentHubHeader } from "../apps/customer-content-hub/CustomerContentHubHeader";
import { PageSkeleton } from "../components/PageSkeleton";
import { Template as TempurLoveGrid } from "./TempurLoveGridTemplate";

export const Template = (
    props: templates.CustomerContentHubRootPageTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <CustomerContentHubHeader love_root={props.love_root} />
        {/* The sealy tempur-love stylesheet scopes the grid's spacing and
            search styling to the legacy island host div's data-template
            attribute, so the wrapper is reproduced here. */}
        <div data-template="TempurLoveGridTemplate">
            <TempurLoveGrid
                filter_by={props.filter_by}
                base_api_url={props.base_api_url}
                initial_grid_data={props.initial_grid_data}
                initial_next_url={props.initial_next_url}
                breadcrumb_items={props.breadcrumb_items}
                root_url={props.root_url}
            />
        </div>
    </PageSkeleton>
);
